import {
  Autocomplete,
  Divider,
  FormControl,
  TextField,
  Typography,
} from "@mui/material";
import Grid from "@mui/material/Grid2";
import React from "react";
import { Control, Controller, UseFormWatch } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { IClient } from "../../../shared/interfaces/client/IClient";
import { IInvoice } from "../../../shared/interfaces/invoice/IInvoice";
import { lightPalette } from "../../../shared/mui/palettes";

interface IProps {
  clients: IClient[];
  watch: UseFormWatch<IInvoice>;
  control: Control<IInvoice>;
  changeFilterHandler: (name: string, value: string | number | null) => void;
}

const InvoiceTo = ({
  clients,
  watch,
  control,
  changeFilterHandler,
}: IProps) => {
  const { t } = useTranslation();
  const selectedClient = clients?.find(
    (client) => client?.id === watch("clientId"),
  );
  return (
    <>
      <Grid container spacing={2} sx={{ alignItems: "start", marginY: "1rem" }}>
        <Grid size={{ xs: 12, md: 5 }}>
          <h3>{t("invoice.to")}:</h3>
          <Typography variant={"subtitle1"} color={lightPalette.text.gray}>
            {t("invoice.clientInformation")}
          </Typography>
        </Grid>
        <Grid size={{ xs: 12, md: 7 }}>
          <Grid container spacing={2}>
            <Grid size={{ xs: 12, md: selectedClient ? 6 : 12 }}>
              <Controller
                name={"clientId"}
                control={control}
                render={({
                  field: { onChange, value },
                  fieldState: { error },
                }) => (
                  <FormControl error={!!error?.message?.length} fullWidth>
                    <Autocomplete
                      disableCloseOnSelect
                      options={clients ?? []}
                      noOptionsText={t("general.noClients")}
                      getOptionLabel={(option) => option?.name}
                      value={
                        clients?.find(
                          (client) => client?.id === Number(value),
                        ) ?? null
                      }
                      onChange={(_, newValue) => {
                        onChange(newValue?.id);
                      }}
                      onInputChange={(_, newInputValue, reason) => {
                        if (reason === "input") {
                          changeFilterHandler("name", newInputValue);
                        }
                      }}
                      renderOption={(props, option) => (
                        <li {...props}>{option?.name}</li>
                      )}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label={t("general.client")}
                          helperText={t(error?.message as string)}
                          error={!!error?.message?.length}
                        />
                      )}
                    />
                  </FormControl>
                )}
              />
            </Grid>
            {selectedClient && (
              <>
                <Grid size={{ xs: 12, md: 6 }}>
                  <TextField
                    value={selectedClient?.email ?? ""}
                    label={t("general.email")}
                    sx={{ width: "100%" }}
                    disabled
                  />
                </Grid>
              </>
            )}
          </Grid>
        </Grid>
      </Grid>
      <Divider />
    </>
  );
};

export default InvoiceTo;
